import { FULL_SIGNATURE, GLOBAL_CATALOGS } from '../types';

const initialState = {
  isLoading: false,
  menus: [],
  value: '',
  result: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },

  
  // 待我審核
  undisposed: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  // 
  processed: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  details: {},
};

const signature = function (state = initialState, action) {
  switch (action.type) {
    case FULL_SIGNATURE.Loading: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    case FULL_SIGNATURE.Value: {
      return {
        ...state,
        value: action.payload
      };
    }
    case FULL_SIGNATURE.Details: {
      return {
        ...state,
        details: action.payload
      };
    }
    case GLOBAL_CATALOGS.SignOff.Root: {
      return {
        ...state,
        menus: action.payload
      };
    }
    case GLOBAL_CATALOGS.SignOff.Waiting.List: {
      return {
        ...state,
        undisposed: action.payload
      };
    }
    case GLOBAL_CATALOGS.SignOff.Signed.List: {
      return {
        ...state,
        processed: action.payload
      };
    }
    default: {
      return state;
    }
  }
};

export default signature;
